import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { GenerateLoyaltyTokenParams } from './request';
import { generateLoyaltyToken } from './request';

/** React‑Query mutation wrapper for `generateLoyaltyToken` */
export const useGenerateLoyaltyTokenMutation = (
  settings?: MutationSettings<
    GenerateLoyaltyTokenParams,
    typeof generateLoyaltyToken
  >
) =>
  useMutation({
    mutationKey: ['generateLoyaltyToken'],
    mutationFn: generateLoyaltyToken, // params include { role, config? }
    ...settings?.options
  });
